var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBarLine',{attrs:{"name":_vm.name,"getDataAction":_vm.getDataAction,"leftName":_vm.leftName,"rightName":_vm.rightName,"isShowCloseBtn":_vm.isShowCloseBtn},on:{"SizeChange":_vm.sizeChange,"StateChange":_vm.stateChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }